import formatRoleLabel from './formatRoleLabel';

export default function formatMembershipRoleLabel({
  isManaged,
  role,
}: {
  isManaged?: boolean | null;
  role?: string | null;
}) {
  const labels: string[] = [];
  if (isManaged) labels.push('Managed User');
  if (role && role !== 'player') labels.push(formatRoleLabel(role));
  return labels.join(' · ') || null;
}
